'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cx } from 'class-variance-authority';
type TableBodyProps = {
  className?: string;
  children: ReactNode;
};
export default function TableBody(t0) {
  const $ = _c(5);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("max-sm:divide-y max-sm:divide-blue-200 max-sm:before:hidden before:block", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <tbody className={t1}>{children}</tbody>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}